export default __webpack_public_path__ + "static/media/brandLogo1.e972e8a3.png";